import * as ethers from "ethers"

export default class Contract {
  constructor(address, abi) {
    const provider = window.web3.currentProvider
    const signer = new ethers.providers.Web3Provider(provider).getSigner()

    this.signer = signer

    this.address = address
    this.contract = new ethers.Contract(address, abi, signer)
  }
}
